import { useCallback, useContext, useEffect, useMemo } from "react";
import { IoLocationOutline } from "react-icons/io5";
import { VscAccount, VscMenu, VscSearch } from "react-icons/vsc";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { PAGES } from "../../constants/pages";
import { useGetGlobalSettings } from "../../hooks/useGlobalSettings";
import { AppContext } from "../../providers/AppProvider";
import { Button } from "../ui/button";
import MenuBar from "./MenuBar";
import { SearchBar } from "./SearchBar";
import "./Sidebar.scss";
export function Sidebar() {
  const navigate = useNavigate();
  const { isShowSearch, setIsShowSearch, isShowMenu, setIsShowMenu } =
    useContext(AppContext);

  const { showMySereni, mySereniLink } = useGetGlobalSettings();
  const location = useLocation();

  const toggleSearchModal = useCallback(() => {
    setIsShowSearch(!isShowSearch);
  }, [isShowSearch]);

  const toggleMenuModal = useCallback(() => {
    setIsShowMenu(!isShowMenu);
  }, [isShowMenu]);

  useEffect(() => {
    if (isShowSearch) setIsShowSearch(false);
    if (isShowMenu) setIsShowMenu(false);
  }, [location.pathname]);

  const menuItems = useMemo(
    () => [
      {
        icon: <VscSearch className="h-7 w-7" />,
        onClick: () => {
          toggleSearchModal();
          if (isShowMenu) toggleMenuModal();
        },
        isActive: isShowSearch,
      },
      {
        icon: <VscMenu className="h-7 w-7" />,
        onClick: () => {
          toggleMenuModal();
          if (isShowSearch) toggleSearchModal();
        },
        isActive: isShowMenu,
      },
      {
        icon: <IoLocationOutline className="h-8 w-8" />,
        onClick: () => {
          navigate(PAGES.BRANCH);
        },
        isActive: location.pathname.indexOf(PAGES.BRANCH) !== -1,
      },
      showMySereni
        ? {
            icon: (
              <Link
                to={
                  mySereniLink?.includes("https:")
                    ? mySereniLink
                    : `${process.env.REACT_APP_BASE_URL}${mySereniLink}`
                }
                target={"_blank"}
                className="text-current"
              >
                <VscAccount strokeWidth={0} className="h-7 w-7" />
              </Link>
            ),
            isActive: false,
          }
        : {},
    ],
    [
      isShowSearch,
      isShowMenu,
      location.pathname,
      showMySereni,
      toggleSearchModal,
      toggleMenuModal,
      navigate,
      mySereniLink,
    ]
  );

  return (
    <>
      <aside className="hidden lg:flex fixed flex-col justify-start h-full bg-white pt-[130px] w-[155px] z-[99]">
        <div className="h-5/6 pt-10 border-0 flex flex-col justify-between relative w-full">
          <div
            className={
              "h-[40%] d-flex justify-between flex-column align-items-center mt-10"
            }
          >
            {menuItems.map((item, index) => (
              <Button
                variant="ghost"
                key={index.toString()}
                className={`w-12 h-12 p-0 ${
                  item.isActive && "bg-grey rounded-lg"
                }`}
                onClick={item.onClick}
              >
                {item.icon}
              </Button>
            ))}
          </div>
        </div>
      </aside>
      <SearchBar
        isShowSearch={isShowSearch}
        toggleSearchModal={toggleSearchModal}
        isShowMenu={isShowMenu}
        toggleMenuModal={toggleMenuModal}
      />
      <MenuBar isShowMenu={isShowMenu} handleClose={toggleMenuModal} />
    </>
  );
}
